import { render, staticRenderFns } from "./SupportingDocuments.vue?vue&type=template&id=70c8b7c0"
import script from "./SupportingDocuments.vue?vue&type=script&lang=js"
export * from "./SupportingDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports